export const CHALLENGE_CONFIG = {
    goalMountains: 100, // Target number of glaciers
    startDate: '06/16/2025 00:00:00', // Challenge start date (MM/DD/YYYY)
    endDate: '09/23/2025 23:59:59' // Challenge end date (MM/DD/YYYY)
};
